/**
 * EmbeddablePage.jsx — bir sayfanın hem KENDİ route'unda hem de başka bir sayfanın
 * sekmesi içinde render edilebilmesi için iki ince sarmalayıcı.
 *
 * 2026-09-12'de eklendi: Firma Profili İncele / Personel Belgeleri İncele / Taşeron
 * Bağlantıları sayfalarının üçü de artık Firma Detay sayfasının (FirmaDetayPage.jsx)
 * birer sekmesi. Üçünü de kopyalamak yerine `embedded` bayrağıyla sadece sayfa
 * kabuğunu (page-content + Container + BreadCrumb) kapatıyoruz — iş mantığı, veri
 * çekme ve modal'lar tek yerde kalıyor.
 *
 * Kullanım:
 *   <PageFrame embedded={embedded}>
 *     <PageBody embedded={embedded} title="…" pageTitle="Firmalar">
 *       …sayfa içeriği…
 *     </PageBody>
 *     …modal'lar (Container DIŞINDA kalmalı)…
 *   </PageFrame>
 */
import React from "react";
import { Container } from "reactstrap";
import BreadCrumb from "./BreadCrumb";

/** Dış kabuk: gömülüyken `page-content` padding'ini (ve dolayısıyla çift boşluğu) atar. */
export const PageFrame = ({ embedded, children }) =>
  embedded ? <>{children}</> : <div className="page-content">{children}</div>;

/** İç kabuk: gömülüyken Container + BreadCrumb'ı atar. */
export const PageBody = ({ embedded, title, pageTitle, children }) =>
  embedded ? (
    <>{children}</>
  ) : (
    <Container fluid>
      <BreadCrumb title={title} pageTitle={pageTitle} />
      {children}
    </Container>
  );
